import React from "react";
import { LOGO_HEADER, LOGO_FOOTER, ADDRESS_LINE, APP_NAME, APP_SUBTITLE } from "@/lib/constants";

export const BrandLogo = ({ compact = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <img src={LOGO_HEADER} alt="Azioni Solidali in Rete" className="h-11 w-11 rounded-full object-contain bg-white shrink-0" />
    {!compact && (
      <div className="leading-tight">
        <div className="font-display font-bold text-[15px] text-[color:var(--brand-blue-700)] tracking-tight">{APP_NAME}</div>
        <div className="text-[10.5px] text-muted-foreground">{APP_SUBTITLE}</div>
      </div>
    )}
  </div>
);

export const BrandFooter = ({ className = "" }) => (
  <footer className={`border-t bg-white ${className}`}>
    <div className="mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center gap-3 sm:justify-between">
      <img src={LOGO_FOOTER} alt="Cantieri Educativi - cooperativa sociale" className="h-10 object-contain" />
      <p className="text-xs text-muted-foreground text-center sm:text-right">{ADDRESS_LINE}</p>
    </div>
  </footer>
);
